import WholeMeProfileRoute from 'pages/wholeme/routes/WholeMeProfileRoute';
import ProfileCompleted from 'pages/wholeme/pages/profile/profileCompleted/ProfileCompleted';
import Goals from '../pages/protege/goals/Goals';
import GoalsFlow from '../pages/protege/goals/CreateGoalFlow';
import GoalsEdit from '../pages/protege/goals/GoalsEdit';
import GoalsSmart from '../pages/protege/goals/SmartGoals';
import GoalsCelebration from '../pages/protege/Celebration';
import NotificationsPage from '../pages/notifications/Notifications';
import BackrGoals from '../pages/backr/goals/Goals';
import BackgroundCheck from '../pages/backr/BackgroundCheck';
import StartBackgroundCheckScreen from '../pages/backr/StartBackgroundCheckScreen';
import UserFeed from '../pages/UserFeed';
import UnifiedUserFeed from '../pages/UnifiedUserFeed';
import TeamList from '../pages/TeamList';
import BackrTeamView from '../pages/backr/BackrTeamView';
import GeneralInvestLanding from '../pages/backr/GeneralInvestLanding';
import BackrGeneralInvest from '../pages/backr/BackrGeneralInvest';
import ProtegeTeamDetails from '../pages/protege/ProtegeTeamDetails';
import BackrTeamDetails from '../pages/backr/BackrTeamDetails';
import MatchingCelebration from '../pages/MatchingCelebration';
import CreatePost from '../pages/CreatePost';
import EditPost from '../pages/EditPost';
import EditAccountInfo from '../pages/profile/EditAccountInfo';
import EditAdditionalInfo from '../pages/profile/EditAdditionalInfo';
import EditProfileInfo from '../pages/profile/EditProfileInfo';
import Comments from '../pages/Comments';
import ReportPage from '../pages/ReportPage';
import PostPage from '../pages/Post';
import MatchQuizResults from '../pages/matching/MatchQuizResults';
import BackgroundCheckMeterScreen from '../pages/backr/checkr/BackgroundCheckMeterScreen';
import CheckrBGCheck from '../pages/backr/CheckrBGCheck';
import Disclosure from '../pages/backr/checkr/Disclosure';
import FairCredit from '../pages/backr/checkr/FairCredit';
import Agreement from '../pages/backr/checkr/Agreement';
import Pay from '../pages/backr/checkr/Pay';
import ProfileIntakeWizardRoute from '../pages/wholeme/routes/ProfileIntakeWizardRoute';
import ProfileIntakePortraitRoute from '../pages/wholeme/routes/ProfileIntakePortraitRoute';
import MatchingWizardRoute from '../pages/wholeme/routes/MatchingWizardRoute';
import FAQ from '../pages/FAQ';
import LogoutPage from '../pages/register/Logout';
import NewFeature from '../pages/oneTimeScreens/NewFeature';
import Catchup from '../pages/catchup/Catchup';

export const appRoutes = [
  {
    path: '/tabs/profile',
    deeplinkPath: '/tabs/profile',
    component: WholeMeProfileRoute,
    protected: true,
  },
  {
    path: '/tabs/feed', deeplinkPath: '/tabs/feed', component: UnifiedUserFeed, protected: true,
  },
  {
    path: '/tabs/teams/admin',
    deeplinkPath: '/tabs/teams/admin',
    component: TeamList,
    protected: true,
  },
  {
    path: '/tabs/teams/admin/:id',
    deeplinkPath: '/tabs/teams/admin',
    component: UserFeed,
    protected: true,
  },
  {
    path: '/tabs/updates',
    deeplinkPath: '/tabs/updates',
    component: NotificationsPage,
    protected: true,
  },
  {
    path: '/tabs/backr/background-check',
    deeplinkPath: '/tabs/backr/background-check',
    component: BackgroundCheck,
    protected: true,
  },
  {
    path: '/tabs/backr/background-check-v2',
    deeplinkPath: '/tabs/backr/background-check-v2',
    component: StartBackgroundCheckScreen,
    protected: true,
  },
  {
    path: '/tabs/goals', deeplinkPath: '/tabs/goals', component: Goals, protected: true,
  },
  {
    path: '/tabs/protege/teams',
    deeplinkPath: '/tabs/protege/teams',
    component: ProtegeTeamDetails,
    protected: true,
  },
  {
    path: '/tabs/backr/teams',
    deeplinkPath: '/tabs/backr/teams',
    component: BackrTeamDetails,
    protected: true,
  },
  {
    path: '/tabs/backr/teams/details/:id',
    deeplinkPath: '/tabs/backr/teams/details',
    component: BackrTeamView,
    protected: true,
  },
  {
    path: '/tabs/backr/general-invest-landing',
    deeplinkPath: '/tabs/backr/general-invest-landing',
    component: GeneralInvestLanding,
    protected: true,
  },
  {
    path: '/tabs/backr/general-invest',
    deeplinkPath: '/tabs/backr/general-invest',
    component: BackrGeneralInvest,
    protected: true,
  },
  {
    path: '/wholeme/portrait',
    deeplinkPath: '/wholeme/portrait',
    component: ProfileIntakePortraitRoute,
    protected: true,
  },
  {
    path: '/wholeme/wizard',
    deeplinkPath: '/wholeme/wizard',
    component: ProfileIntakeWizardRoute,
    protected: true,
  },
  {
    path: '/wholeme/wizard/:categoryId',
    deeplinkPath: '/wholeme/wizard',
    component: ProfileIntakeWizardRoute,
    protected: true,
  },
  {
    path: '/wholeme/wizard/:categoryId/:stepId',
    deeplinkPath: '/wholeme/wizard',
    component: ProfileIntakeWizardRoute,
    protected: true,
  },
  {
    path: '/wholeme/wizard/:categoryId/:stepId/:isFromGrow',
    deeplinkPath: '/wholeme/wizard',
    component: ProfileIntakeWizardRoute,
    protected: true,
  },
  {
    path: '/wholeme/pre-matching',
    deeplinkPath: '/wholeme/pre-matching',
    component: MatchingWizardRoute,
    protected: true,
  },
  {
    path: '/new-feature', deeplinkPath: '/new-feature', component: NewFeature, protected: true,
  },
  {
    path: '/goals-create',
    deeplinkPath: '/goals-create',
    component: GoalsFlow,
    protected: false,
  },
  {
    path: '/goals-create/smart',
    deeplinkPath: '/goals-create/smart',
    component: GoalsSmart,
    protected: false,
  },
  {
    path: '/goals-edit', deeplinkPath: '/goals-edit', component: GoalsEdit, protected: false,
  },
  {
    path: '/goals-edit/smart',
    deeplinkPath: '/goals-edit/smart',
    component: GoalsSmart,
    protected: false,
  },
  {
    path: '/goals/celebration',
    deeplinkPath: '/goals/celebration',
    component: GoalsCelebration,
    protected: true,
  },
  {
    path: '/profile/goals/:id',
    deeplinkPath: '/profile/goals',
    component: BackrGoals,
    protected: true,
  },
  {
    path: '/post', deeplinkPath: '/post', component: CreatePost, protected: false,
  },
  {
    path: '/post-edit', deeplinkPath: '/post-edit', component: EditPost, protected: false,
  },
  {
    path: '/tabs/profile/edit-account-info',
    deeplinkPath: '/tabs/profile/edit-account-info',
    component: EditAccountInfo,
    protected: false,
  },
  {
    path: '/tabs/profile/edit-additional-info',
    deeplinkPath: '/tabs/profile/edit-additional-info',
    component: EditAdditionalInfo,
    protected: false,
  },
  {
    path: '/tabs/profile/edit-profile-info',
    deeplinkPath: '/tabs/profile/edit-profile-info',
    component: EditProfileInfo,
    protected: false,
  },
  {
    path: '/profile/:id',
    deeplinkPath: '/profile',
    component: WholeMeProfileRoute,
    protected: true,
  },
  {
    path: '/celebrations/:id',
    deeplinkPath: '/celebrations',
    component: MatchingCelebration,
    protected: false,
  },
  {
    path: '/posts/:id', deeplinkPath: '/posts', component: PostPage, protected: false,
  },
  {
    path: '/posts/:id/comments',
    deeplinkPath: '/posts',
    component: Comments,
    protected: true,
  },
  {
    path: '/catchup',
    deeplinkPath: '/catchup',
    component: Catchup,
    protected: true,
  },
  {
    path: '/:type/:id/report',
    deeplinkPath: '/report',
    component: ReportPage,
    protected: false,
  },
  {
    path: '/faq', deeplinkPath: '/faq', component: FAQ, protected: false,
  },
  {
    path: '/match-preview-screen',
    deeplinkPath: '/match-preview-screen',
    component: MatchQuizResults,
    protected: false,
  },
  {
    path: '/background-status-meter',
    deeplinkPath: '/background-status-meter',
    component: BackgroundCheckMeterScreen,
    protected: false,
  },
  {
    path: '/checkr-form',
    deeplinkPath: '/checkr-form',
    component: CheckrBGCheck,
    protected: false,
  },
  {
    path: '/checkr-disclosure',
    deeplinkPath: '/checkr-disclosure',
    component: Disclosure,
    protected: false,
  },
  {
    path: '/checkr-fair-credit',
    deeplinkPath: '/checkr-fair-credit',
    component: FairCredit,
    protected: false,
  },
  {
    path: '/checkr-agreement',
    deeplinkPath: '/checkr-agreement',
    component: Agreement,
    protected: false,
  },
  {
    path: '/checkr-pay', deeplinkPath: '/checkr-pay', component: Pay, protected: false,
  },
  {
    path: '/profile-completed',
    deeplinkPath: '/profile-completed',
    component: ProfileCompleted,
    protected: false,
  },
  {
    path: '/register/logout',
    deeplinkPath: null,
    component: LogoutPage,
    protected: false,
  },
];
